import { useMemo } from 'react';
import { useAngularContext } from 'AngularContext';
import { type AnyObject } from '@Types';

/*
    FormatsText#stripFormatting, which the key terms selectors need.

    It stays on Angular because it handles MathJax and markdown and is used across the app. The
    selectors take it as an argument rather than reaching for the injector themselves, so they stay pure
    and testable.
*/
export function useStripFormatting() {
    const $injector = useAngularContext();

    return useMemo(() => {
        const formatsText = $injector.get<AnyObject<(text: string) => string>>('FormatsText');
        return (text: string) => formatsText.stripFormatting(text);
    }, [$injector]);
}
